var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "first-time-modal" },
    [
      _c("modal-header", {
        attrs: {
          "logo-img-src": require("@/assets/image/homebase/aone_logo.svg"),
          "on-modal-close": _vm.close
        }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("modal-footer", {
        staticClass: "text-center",
        attrs: { buttonConfigs: [_vm.buttonConfig] }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex justify-content-center pt-3 pb-5" },
      [
        _c("div", { staticClass: "modal-body text-center" }, [
          _c("div", { staticClass: "welcome-msg" }, [
            _vm._v("\n        Welcome to the "),
            _c("span", { staticClass: "modal-text-bold" }, [_vm._v("new")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pb-2 pr-xl-2" }, [
            _c("img", {
              staticClass: "aone-logo",
              attrs: {
                src: require("@/assets/image/homebase/aone_logo_black.svg"),
                alt: "Autodesk One"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-description pb-4" }, [
            _vm._v("\n        We've integrated "),
            _c("span", { staticClass: "modal-text-bold" }, [
              _vm._v("Employee Hub")
            ]),
            _vm._v(" and\n        "),
            _c("span", { staticClass: "modal-text-bold" }, [
              _vm._v("Autodesk One")
            ]),
            _vm._v(". View the video to\n        learn more.\n      ")
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "max-width": "640px" } }, [
            _c("div", [
              _c(
                "video",
                {
                  attrs: {
                    controls: "",
                    poster:
                      "https://del6fkf4zntcx.cloudfront.net/images/AutodeskOne-video-poster.png"
                  }
                },
                [
                  _c("source", {
                    attrs: {
                      src:
                        "https://del6fkf4zntcx.cloudfront.net/videos/autodeskone-merger-video.mp4",
                      type: "video/mp4"
                    }
                  })
                ]
              )
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cdabe35", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cdabe35","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/modals/FirstTimeVisitModal.vue
// module id = null
// module chunks = 